import { render, staticRenderFns } from "./advtrxhist.vue?vue&type=template&id=5e77d666&scoped=true"
import script from "./advtrxhist.vue?vue&type=script&lang=js"
export * from "./advtrxhist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e77d666",
  null
  
)

export default component.exports